// @flow
import React from 'react';
import { AvatarContext } from '@sonyged/ext-proc';

import startImage1 from '../../../assets/images/pages/sushi/sushi_field_start_1@3x.png';
import startImage2 from '../../../assets/images/pages/sushi/sushi_field_start_1@3x.png';
import startImage3 from '../../../assets/images/pages/sushi/sushi_field_start_1@3x.png';
import './modal.css';

const startImage = {
  '1': startImage1,
  '2': startImage2,
  '3': startImage3,
};

type Props = {
  init: boolean,
  half: 'first' | 'second',
  moreKanji?: boolean,
};

const StartModal = ({ init, half, moreKanji = false }: Props) => {
  if (!init) {
    return <span />;
  }

  return (
    <div className={'start-view-container proc-border-radius center-aligned secondary20-border-color'}>
      <div className={'background absolute white-bg-color'} />
      {/* <div className={`contents ${this.props.research ? 'research' : ''}`}> */}
      <div className={'contents research'}>
        <AvatarContext.Consumer>
          {avatar => {
            return <img className="image" src={startImage[avatar ? avatar : 1]} />;
          }}
        </AvatarContext.Consumer>
        <div className={'title proc-large-font secondary100-color'}>
          {half === 'first' && '前半スタート！'}
          {half === 'second' && '後半スタート！'}
        </div>
        <div className={'desc proc-medium-font gray100-color'}>
          {moreKanji ? '何皿食べてくれるかな？' : '何さら食べてくれるかな？'}
        </div>
      </div>
    </div>
  );
};
export default StartModal;
